import React from "react";

function Curriculum() {
  return <div>Curriculum</div>;
}

export default Curriculum;
